import { Component, OnInit } from '@angular/core';
import { CustomBreadcrumbService } from 'src/app/services/breadcrumb.service';
import { PreviousRouteService } from './services/previous-route-service.service';
import { BreadcrumbService } from 'xng-breadcrumb';
import { NavigationHistoryService } from './services/navigation-history/navigation-history.service';
import { RouterOutlet } from '@angular/router';
import { ToastComponent } from '@tekus/design-system/components/toast';

declare global {
  interface Window {
    updateMediaList: () => void;
    openUploader: () => void;
  }
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [CustomBreadcrumbService, BreadcrumbService],
  imports: [RouterOutlet, ToastComponent]
})
export class AppComponent implements OnInit {
  constructor(
    private previousRouteService: PreviousRouteService,
    private readonly customBreadcrumbService: CustomBreadcrumbService,
    private readonly navigationHistoryService: NavigationHistoryService
  ) {}

  ngOnInit(): void {
    this.previousRouteService.getPreviousUrl();
    this.customBreadcrumbService.changeLabel();
  }
}
